(() => {
  const dialog = document.querySelector('[data-popup-cadastro]');
  if (!dialog || typeof dialog.showModal !== 'function') return;

  const COOKIE = 'popup-cadastro';
  const formId = dialog.dataset.formId;
  const form = dialog.querySelector('form');
  const expireDays = parseInt(dialog.dataset.expire, 10) || 7;
  const delay = parseInt(dialog.dataset.delay, 10) || 0;
  const image = dialog.querySelector('.popup-cadastro__image');
  const birthday = dialog.querySelector('[data-popup-cadastro-birthday]');
  const tagsInput = dialog.querySelector('[data-popup-cadastro-tags]');
  const isPreview = dialog.hasAttribute('data-preview');
  const posted = location.hash === `#${formId}`;
  const postedSuccess = posted && new URLSearchParams(location.search).get('customer_posted') === 'true';
  const postedError = posted && dialog.querySelector('[data-popup-cadastro-error]');

  const setCookie = (days) => {
    const date = new Date();
    date.setTime(date.getTime() + days * 864e5);
    document.cookie = `${COOKIE}=closed;expires=${date.toUTCString()};path=/;SameSite=Lax`;
  };
  const hasCookie = () => document.cookie.split('; ').some((c) => c.startsWith(`${COOKIE}=`));

  const open = () => {
    if (dialog.open) return;
    if (image) image.loading = 'eager';
    dialog.showModal();
  };

  const close = () => {
    dialog.close();
  };

  // Fechar: botão, clique fora (backdrop) e Esc (nativo do <dialog>)
  dialog.querySelector('[data-popup-cadastro-close]').addEventListener('click', close);
  dialog.addEventListener('click', (event) => {
    if (event.target === dialog) close();
  });
  dialog.addEventListener('close', () => {
    if (!isPreview) setCookie(expireDays);
  });

  // Links do termo de consentimento abrem em nova aba
  dialog.querySelectorAll('.popup-cadastro__consent-text a').forEach((link) => {
    link.target = '_blank';
    link.rel = 'noopener';
  });

  // Máscara DD/MM/AAAA
  const parseBirthday = (value) => {
    const match = /^(\d{2})\/(\d{2})\/(\d{4})$/.exec(value);
    if (!match) return null;
    const [, d, m, y] = match.map(Number);
    const date = new Date(y, m - 1, d);
    const valid = date.getFullYear() === y && date.getMonth() === m - 1 && date.getDate() === d
      && y >= 1900 && date <= new Date();
    return valid ? match[0] : null;
  };

  if (birthday) {
    birthday.addEventListener('input', () => {
      const digits = birthday.value.replace(/\D/g, '').slice(0, 8);
      birthday.value = [digits.slice(0, 2), digits.slice(2, 4), digits.slice(4)].filter(Boolean).join('/');
      birthday.setCustomValidity('');
    });
  }

  form.addEventListener('submit', (event) => {
    const tags = ['newsletter', 'popup-cadastro'];

    if (birthday && birthday.value) {
      const date = parseBirthday(birthday.value);
      if (!date) {
        event.preventDefault();
        birthday.setCustomValidity('Informe uma data válida no formato DD/MM/AAAA.');
        birthday.reportValidity();
        return;
      }
      tags.push(`nascimento:${date}`);
    }

    if (dialog.querySelector('[data-popup-cadastro-consent]')) tags.push('aceite-lgpd');

    tagsInput.value = tags.join(',');
    setCookie(expireDays);
  });

  // Copiar cupom
  const copyBtn = dialog.querySelector('[data-popup-cadastro-copy]');
  if (copyBtn) {
    copyBtn.addEventListener('click', () => {
      navigator.clipboard?.writeText(copyBtn.dataset.popupCadastroCopy).then(() => {
        const label = copyBtn.querySelector('[data-copy-label]');
        label.textContent = label.dataset.copied;
      });
    });
  }

  // Retorno do envio: mostra sucesso ou erro no próprio popup
  if (postedSuccess) {
    dialog.querySelector('[data-popup-cadastro-fields]').hidden = true;
    dialog.querySelector('[data-popup-cadastro-success]').hidden = false;
    history.replaceState(null, '', location.pathname);
    open();
    return;
  }

  if (postedError) {
    open();
    return;
  }

  if (isPreview) {
    open();
    return;
  }

  if (hasCookie()) return;

  // Pré-carrega a imagem antes de abrir, sem bloquear o carregamento da página
  const schedule = () => {
    if (image) setTimeout(() => { image.loading = 'eager'; }, Math.max(delay - 1500, 0));
    setTimeout(open, delay);
  };

  if (document.readyState === 'complete') schedule();
  else window.addEventListener('load', schedule, { once: true });
})();
